import { Box } from '@chakra-ui/react';
import { Checkbox } from '@kula-ai/components';

export interface IcsAttachmentCheckboxProps {
  checked: boolean;
  onChange: (_checked: boolean) => void;
}

export const IcsAttachmentCheckbox = ({
  checked,
  onChange,
}: IcsAttachmentCheckboxProps) => (
  <Box pt="3" pb="1">
    <Checkbox
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      size="md"
    >
      Include calendar invite as an attachment (.ics file)
    </Checkbox>
  </Box>
);
